import endSelection from './endSelection';
const handleKeyboardEvent = ({ suggestions, suggestedValue, setSuggestedValue, setEnteredValue, onSelection, setIsNavigated, isToggled, setOn, setOff, enteredValue }) => (e) => {
    const highlightedSuggestionIdx = suggestions.indexOf(suggestedValue);
    const firstSuggestion = suggestions[0];
    const lastSuggestion = suggestions[suggestions.length - 1];
    // up, down
    if ([38, 40].includes(e.which)) {
        setOn();
        setIsNavigated(true);
    }
    switch (e.which) {
        case 9: // tab
            endSelection(suggestedValue, setEnteredValue, setOff, setIsNavigated, onSelection);
            break;
        case 13: // enter
            e.preventDefault();
            e.stopPropagation();
            endSelection(suggestedValue, setEnteredValue, setOff, setIsNavigated, onSelection);
            break;
        case 27: // esc
            isToggled && e.stopPropagation();
            setSuggestedValue(enteredValue);
            setOff();
            setIsNavigated(false);
            break;
        case 38: // up
            if (suggestedValue && highlightedSuggestionIdx !== -1) {
                if (suggestedValue === firstSuggestion) {
                    setSuggestedValue('');
                }
                else {
                    setSuggestedValue(suggestions[highlightedSuggestionIdx - 1]);
                }
            }
            else {
                setSuggestedValue(lastSuggestion);
            }
            break;
        case 40: // down
            if (suggestedValue && highlightedSuggestionIdx !== -1) {
                if (suggestedValue === lastSuggestion) {
                    setSuggestedValue('');
                }
                else {
                    setSuggestedValue(suggestions[highlightedSuggestionIdx + 1]);
                }
            }
            else {
                setSuggestedValue(firstSuggestion);
            }
            break;
        default:
    }
};
/* eslint-enable */
export default handleKeyboardEvent;
//# sourceMappingURL=handleKeyboardEvent.js.map